import "../../shared/components/wizard_modal.js";
import "../../../../../lib/assets/javascripts/assert.js";

jQuery(function () {
  var assert = new Asserter({ userMessage: "An error occurred while preparing to save" });
  var unsavedNotice = jQuery("[data-behavior~=unsaved-notice]");

  // BEHAVIOUR

  // VITE_MIGRATION: beforeunload unsaved-warning temporarily disabled while we
  // smoke-test the admin edit page under Vite. The form dirty-tracking below
  // still runs; only the browser-level "Leave site?" prompt is suppressed so
  // repeated reloads during debugging don't require manual dismissal.
  // jQuery(window).on('beforeunload', handleUnload);
  jQuery(document).on("click", "[data-save-form-before-navigation]", handleOptionalSaveNavigation);
  jQuery(document).on("input change", 'form[data-unsaved-warning="true"]', handleFormChange);
  jQuery(document).on("submit", 'form[data-unsaved-warning="true"]', handleFormSubmit);

  // EVENT HANDLERS

  function handleUnload() {
    // Warn if the form changes are unsaved
    var unsavedForms = jQuery("form[data-unsaved]");
    if (unsavedForms.length) {
      var warning = unsavedForms.first().data("unsaved-warning");
      return warning === true ? "You haven't saved your changes." : warning;
    }
  }

  function handleFormChange(event) {
    var input = jQuery(event.target);

    if (!input.is('[class~="tab-selectors"] input')) {
      // prevent warning when just switching tabs inside the form
      setDirty(this);
      input.closest(".field").addClass("unsaved"); // Dirty indicator
    }
  }

  function handleFormSubmit() {
    clearDirty(this);
  }

  function handleOptionalSaveNavigation(event) {
    event.preventDefault();
    var form = assert.element(jQuery(this).data("save-form-before-navigation"));
    var href = jQuery(this).attr("href");
    showSaveOptionModal(form, href);
  }

  // HELPER FUNCTIONS

  function showSaveOptionModal(form, href) {
    var modal = new WizardModal({
      destroyOnHide: true,
      completeButtons: [
        {
          text: "Discard changes",
          beforeComplete: function () {
            continueToHref(form, href);
          },
        },
        {
          text: "Save changes",
          beforeComplete: function () {
            saveAndContinueToHref(form, href);
          },
        },
      ],
    });

    modal.addPage({
      header: "Document has been modified",
      body: "Would you like to save your changes before continuing?",
    });
    modal.show();
  }

  function saveAndContinueToHref(form, href) {
    // Use the return_to responder to continue to the original href after submitting the form
    form.append(jQuery("<input>", { type: "hidden", name: "return_to", value: href }));
    form.trigger("submit");
    clearDirty();
  }

  function continueToHref(form, href) {
    clearDirty(form);
    window.location = href;
  }

  function setDirty(form) {
    jQuery(form).attr("data-unsaved", true);
    unsavedNotice.show();
  }

  function clearDirty(form) {
    jQuery(form).removeAttr("data-unsaved");
    unsavedNotice.hide();
  }
});
